import React from 'react'
import { useGetSession } from 'components/sessions/queries'
import { reconnectWebSocket } from '../../app/graphqlClient'

export const SessionContext = React.createContext()

export function SessionContextProvider(props) {
  const currentSession = localStorage.getItem('session')
  const [session, setSession] = React.useState(JSON.parse(currentSession))

  const username = React.useMemo(() => session?.user?.username, [session])
  const isGuest = React.useMemo(() => session?.user?.isGuest, [session])

  const persistSession = (newSession) => {
    localStorage.setItem('session', JSON.stringify(newSession))
    setSession(newSession)

    // Reconnect WebSocket with new authentication
    setTimeout(() => {
      reconnectWebSocket()
    }, 100) // Small delay to ensure cookies are set
  }

  const deleteSession = () => {
    localStorage.clear()
    setSession(null)

    // Reconnect WebSocket to clear authentication
    setTimeout(() => {
      reconnectWebSocket()
    }, 100)
  }

  const handleExpiredSession = (error) => {
    if (
      error?.networkError?.result?.errors[0]?.extensions?.code ===
      'UNAUTHENTICATED'
    )
      deleteSession()
  }

  const useChallengeSession = () => {
    // If session is set, get backend to decode token and respond with current session
    const { error } = useGetSession({ skip: !currentSession })
    // If backend cannot decode the token, reset the session to null
    if (error) {
      console.log('Token out of date, resetting session')
      deleteSession()
    }
  }

  useChallengeSession()
  const value = {
    session,
    isGuest,
    username,
    persistSession,
    deleteSession,
    useChallengeSession,
    handleExpiredSession,
  }
  return <SessionContext.Provider {...props} value={value} />
}

export const useSessionContext = () => React.useContext(SessionContext)
